// Container-width hook for the embeddable competitions components.
//
// The components are self-contained (props only) and can be embedded in any
// column, so responsive behaviour keys off the CONTAINER width, not the
// viewport. jsdom has no ResizeObserver — the hook then keeps the initial
// width (desktop default), which is what the render tests rely on.
import { useEffect, useRef, useState } from "react";

const useContainerWidth = (initial = 1024) => {
  const ref = useRef(null);
  const [width, setWidth] = useState(initial);

  useEffect(() => {
    const node = ref.current;
    if (!node || typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver((entries) => {
      const w = entries[0] && entries[0].contentRect
        ? entries[0].contentRect.width
        : node.clientWidth;
      if (w) setWidth(w);
    });
    observer.observe(node);
    if (node.clientWidth) setWidth(node.clientWidth);
    return () => observer.disconnect();
  }, []);

  return [ref, width];
};

export default useContainerWidth;
